import { API_NAMES, initApi } from "@usas/ui-web/utils/HttpApiHelper";

const postAccountCreateStep1Data = (stepObj, state, setState) => {
  if (stepObj) {
    const api = initApi(API_NAMES.SECURITY, state, setState);
    const url = `/Account/CreateStep1`;

    return api?.executeObject ? api.executeObject(url, 'POST', stepObj) : null;
  }
};

const postAccountCreateStep2Data = (stepObj, state, setState) => {
  if (stepObj) {
    const api = initApi(API_NAMES.SECURITY, state, setState);
    const url = `/Account/CreateStep2`;

    return api?.executeObject ? api.executeObject(url, 'POST', stepObj) : null;
  }
};

const postParentVerifcation = (phoneNumber, state, setState) => {
  if (phoneNumber) {
    const api = initApi(API_NAMES.SECURITY, state, setState);
    const url = `/Account/ParentVerification/${encodeURIComponent(phoneNumber)}`;

    return api?.executeObject ? api.executeObject(url, 'GET') : null;
  }
};

const postInviteUser = (email, firstName, lastName, returnUrl, state, setState) => {
  console.log(`Preparing to call InviteUser API with email: ${email}, firstName: ${firstName}, lastName: ${lastName}, returnUrl: ${returnUrl}`);
  if (email && firstName && lastName && returnUrl) {
    const api = initApi(API_NAMES.SECURITY, state, setState);
    const url = `/Identity/InviteUser`;
    const inviteData = {
      email,
      firstName,
      lastName,
      returnUrl
    };

    return api?.executeObject ? api.executeObject(url, 'POST', inviteData) : null;
  }
};

const AccountCreationData = {
  postAccountCreateStep1Data,
  postAccountCreateStep2Data,
  postParentVerifcation,
  postInviteUser
};

export default AccountCreationData;